import React, { useState } from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import { makeStyles } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Fade from "@material-ui/core/Fade";

const useStyles = makeStyles((theme) => ({
  menuItem: {
    backgroundColor: ({ isSubMenuOpen }) =>
      isSubMenuOpen ? theme.palette.action.hover : "transparent",
  },
}));

export const FadeMenu = ({
  onEditItem,
  onDelete,
  children,
  options,
  classNameLabel,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSubEl, setAnchorSubEl] = useState(null);
  const open = Boolean(anchorEl);
  const openSub = Boolean(anchorSubEl);

  const classes = useStyles({ isSubMenuOpen: openSub });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOpenSubmenu = (event) => {
    setAnchorSubEl(event.currentTarget);
  };

  const handleCloseSubmenu = () => {
    setAnchorSubEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    onEditItem();
  };

  const handleDelete = () => {
    onDelete();
  };

  return (
    <div>
      <IconButton
        label="control"
        aria-controls="fade-menu"
        aria-haspopup="true"
        onClick={handleClick}
        aria-label="settings"
      >
        {children}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        {options.length > 0
          ? options.map(
              ({
                label,
                action,
                disabled = false,
                type = "item",
                subOptions = [],
              }) => {
                if (type === "submenu") {
                  return (
                    <MenuItem
                      autoFocus={false}
                      disabled={disabled}
                      disableRipple
                      key={label}
                      className={classes.menuItem}
                      onMouseEnter={handleOpenSubmenu}
                      onMouseLeave={handleCloseSubmenu}
                    >
                      {label}
                      <Menu
                        style={{ pointerEvents: "none" }}
                        anchorEl={anchorSubEl}
                        open={openSub}
                        getContentAnchorEl={null}
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        PaperProps={{
                          elevation: 4,
                        }}
                      >
                        <div style={{ pointerEvents: "auto" }}>
                          {subOptions.map((subOption) => {
                            const {
                              label: subLabel,
                              disabled: subDisabled,
                              action: subAction,
                            } = subOption;
                            return (
                              <MenuItem
                                key={subLabel}
                                disabled={subDisabled}
                                onClick={subAction}
                              >
                                {subLabel}
                              </MenuItem>
                            );
                          })}
                        </div>
                      </Menu>
                    </MenuItem>
                  );
                }
                return (
                  <MenuItem
                    key={label}
                    disabled={disabled}
                    onClick={action}
                    className={classNameLabel}
                  >
                    {label}
                  </MenuItem>
                );
              }
            )
          : [
              <MenuItem key="Edit" onClick={handleEdit}>
                Edit
              </MenuItem>,
              <MenuItem key="Delete" onClick={handleDelete}>
                Delete
              </MenuItem>,
            ]}
      </Menu>
    </div>
  );
};
FadeMenu.propTypes = {
  classNameLabel: PropTypes.string,
  onEditItem: PropTypes.func,
  onDelete: PropTypes.func,
  children: PropTypes.node.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      type: PropTypes.string,
      action: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
      subOptions: PropTypes.instanceOf(Array),
    })
  ),
};

FadeMenu.defaultProps = {
  classNameLabel: "",
  options: [],
  onEditItem: () => null,
  onDelete: () => null,
};
